/**
 * Money rendering, in one place.
 *
 * `.toFixed(2)` fixes the decimals and does nothing else, so a four-figure
 * amount lands as "$2618.04" — the eye parses that as an unfamiliar number
 * before it parses it as money. On a checkout or a payment plan that costs the
 * customer a beat at exactly the wrong moment; on an admin screen it makes
 * reconciliation slower and misreads likelier.
 *
 * The `$` stays at the call site: JSX frequently styles the sign separately,
 * toasts interpolate it mid-sentence, and several places prefix `-` or `+`.
 * That matches the local `fmtCurrency` helpers this consolidates.
 *
 * Non-finite input renders as 0.00 rather than "NaN" — a missing figure should
 * read as nothing owed, never as a broken screen.
 */

const GROUPED = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Dollars in, grouped digits out: 2618.04 → "2,618.04" */
export function fmtAmount(dollars) {
  const n = Number(dollars);
  return GROUPED.format(Number.isFinite(n) ? n : 0);
}

/** Cents in, grouped dollars out: 261804 → "2,618.04" */
export function fmtCurrency(cents) {
  const n = Number(cents);
  return GROUPED.format(Number.isFinite(n) ? n / 100 : 0);
}
